import { privateAxios } from "../axiosInstances";

/** The access PDF of a cash register sale, the same one the buyer would get by email. */
export const fetchCashRegisterAccessTitlesPdf = async (
  cashRegisterId: string,
  orderId: string
) => {
  const { data } = await privateAxios.get<ArrayBuffer>(
    `/cash-register/${cashRegisterId}/orders/${orderId}/access-titles-pdf`,
    { responseType: "arraybuffer" }
  );

  return data;
};
